import { useState, useEffect } from "react";
import api from "@/lib/api";
import { useStudio } from "@/context/StudioContext";
import { PageHeader, Panel, Loading, Tag } from "@/components/common";
import { TrashSimple, ArrowCounterClockwise } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Trash() {
  const { active } = useStudio();
  const [items, setItems] = useState(null);
  const load = () => api.get("/trash").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, [active?.id]);

  const restore = async (it) => { await api.post("/trash/restore", { data: { type: it.type, id: it.id } }); toast.success("Restored"); load(); };
  const purge = async (it) => { if (window.confirm("Delete permanently? This cannot be undone.")) { await api.delete(`/trash?type=${it.type}&id=${it.id}`); toast.success("Permanently deleted"); load(); } };

  if (!items) return <Loading />;

  return (
    <div>
      <PageHeader icon={TrashSimple} title="Trash"
        subtitle="Deleted content is kept here so you can restore it. Permanent deletion is manual and off by default." />
      {items.length === 0 ? <p className="text-sm text-zinc-500">Trash is empty for {active.name}.</p> : (
        <Panel className="p-0 overflow-hidden">
          {items.map((it, i) => (
            <div key={it.id} data-testid={`trash-${it.id}`} className={`flex items-center gap-4 p-4 ${i !== items.length - 1 ? "border-b border-white/5" : ""}`}>
              <Tag className="text-[10px] capitalize">{it.type}</Tag>
              <div className="flex-1 min-w-0"><div className="text-white truncate">{it.name}</div><div className="text-xs text-zinc-500">Deleted {it.deleted_at ? new Date(it.deleted_at).toLocaleString() : "—"}</div></div>
              <button data-testid={`restore-${it.id}`} onClick={() => restore(it)} className="inline-flex items-center gap-1.5 rounded-full border border-[#00FF9D]/40 text-[#00FF9D] px-3 py-1.5 text-xs"><ArrowCounterClockwise size={13} /> Restore</button>
              <button data-testid={`perma-${it.id}`} onClick={() => purge(it)} className="inline-flex items-center gap-1.5 rounded-full border border-[#FF3366]/40 text-[#FF3366] px-3 py-1.5 text-xs"><TrashSimple size={13} /> Delete</button>
            </div>
          ))}
        </Panel>
      )}
    </div>
  );
}
